module.exports = __webpack_public_path__ + "img/desc-hl.93184290.png";